import React from 'react';

export const ArrowRightCarousel = (): JSX.Element => (
  <svg width="80" height="30" viewBox="0 0 80 30">
    <rect rx="15" ry="15" width="80" height="30" fill="#2c6da4" />
    <path
      d="M35 15 L45 15 M45 15 L40 10 M45 15 L40 20"
      stroke="#fff"
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowRightCarousel;
